export default __webpack_public_path__ + "static/media/l1.74fa8e1c.jpg";